/**
 * Custom hook for managing client/followup status configurations
 * Provides centralized status color mappings and helper functions
 */

const useClientStatus = () => {
    // Status to color mapping for badge styling
    const STATUS_COLOR_MAP = {
        new: "primary",
        qualified: "info",
        processing: "warning",
        confirmed: "success",
        newBuyer: "primary",
        followupDone: "warning",
        priceQuoted: "info",
        negotiation: "warning",
        carBooked: "success",
        paperWork: "warning",
        carSold: "info",
        lost: "danger",
    }

    /**
     * Get the color class for a given status
     * @param {string} status - The status key
     * @returns {string} - The color class (e.g., "primary", "success")
     */
    const getStatusColor = (status) => {
        return STATUS_COLOR_MAP[status] || "primary"
    }

    return {
        STATUS_COLOR_MAP,
        getStatusColor,
    }
}

export default useClientStatus
